export const normalizer = data => ({
    status: data.Status,
    limit: data.ApprovedLimit,
    isPercent: data.IsPercent,
    description: data.Observation,
});
